import React from 'react';
import type { PaperProps } from '@mui/material/Paper';
import { PanelRoot } from './Panel.styles';

export type PanelProps = PaperProps;

export const Panel = (props: PanelProps) => <PanelRoot variant="outlined" {...props} />;
